// Inline SVG icons for transport buttons (Play/Pause/Stop), shared between
// Performance mode and the standalone Metronome tab. SVG rather than
// Unicode glyphs (▶ ❘❘ ■): Android's font rendering of text-based symbols
// can vary by system font or fall back to a colored emoji glyph, which is
// an unacceptable risk for the single most important button on the screen.
// An SVG shape renders identically everywhere.

export const ICON_PLAY =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><polygon points="6,3 21,12 6,21" fill="currentColor"/></svg>';

export const ICON_PAUSE =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><rect x="5" y="3" width="5" height="18" rx="1" fill="currentColor"/><rect x="14" y="3" width="5" height="18" rx="1" fill="currentColor"/></svg>';

export const ICON_STOP =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><rect x="4" y="4" width="16" height="16" rx="2" fill="currentColor"/></svg>';

export const ICON_RESTART =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><rect x="4" y="3" width="3" height="18" fill="currentColor"/><polygon points="20,3 20,21 7,12" fill="currentColor"/></svg>';

export const ICON_LOOP =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><path d="M17 2l4 4-4 4" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 11V9a4 4 0 0 1 4-4h14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M7 22l-4-4 4-4" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 13v2a4 4 0 0 1-4 4H3" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';

export const ICON_PREV =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><rect x="4" y="4" width="2.5" height="16" fill="currentColor"/><polygon points="19,4 19,20 8,12" fill="currentColor"/></svg>';

export const ICON_NEXT =
  '<svg viewBox="0 0 24 24" class="btn-transport-icon-svg" aria-hidden="true"><rect x="17.5" y="4" width="2.5" height="16" fill="currentColor"/><polygon points="5,4 5,20 16,12" fill="currentColor"/></svg>';
